import {
  ROUTE_INBOX,
  ROUTE_TAGS,
  ROUTE_TASKS,
  ROUTE_TIMERS,
} from "@/constants/routes.constants";
import SidebarFavorites from "@/infrastructure/Sidebar/SidebarFavorites/sidebarFavorites.component";
import { Button } from "@/shadcn/components/ui/button";
import { StopwatchIcon } from "@radix-ui/react-icons";
import { CheckCircle, Inbox, Tags } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router";

type SidebarProps = {
  currPage: string;
};

const Sidebar: React.FC<SidebarProps> = ({ currPage }) => {
  const nav = useNavigate();

  return (
    <div
      className={`bg-gray-700 w-[110px] md:w-[125px] 2xl:w-[200px] flex-shrink-0 text-white h-full hidden sm:block overflow-hidden`}
    >
      <div className="p-1 pt-3 md:p-3 h-full overflow-hidden flex flex-col">
        <div className="grid gap-2 w-full">
          <Button
            variant={"ghost"}
            className={`bg-transparent text-left flex justify-start items-center gap-2 transition-all ${
              currPage === "tasks" ? "bg-gray-800 font-bold" : ""
            } [@media(max-height:700px)]:h-8 [@media(max-height:700px)]:rounded-md [@media(max-height:700px)]:px-3 [@media(max-height:700px)]:text-xs`}
            onClick={() => nav(ROUTE_TASKS)}
          >
            <CheckCircle
              className={`!size-4 [@media(max-height:700px)]:!size-[14px]`}
            />
            Tasks
          </Button>
          <Button
            variant={"ghost"}
            className={`bg-transparent text-left flex justify-start items-center gap-2 transition-all ${
              currPage === "timers" ? "bg-gray-800 font-bold" : ""
            } [@media(max-height:700px)]:h-8 [@media(max-height:700px)]:rounded-md [@media(max-height:700px)]:px-3 [@media(max-height:700px)]:text-xs`}
            onClick={() => nav(ROUTE_TIMERS)}
          >
            <StopwatchIcon
              className={`!size-4 [@media(max-height:700px)]:!size-[14px]`}
            />
            Timers
          </Button>
          <Button
            variant={"ghost"}
            className={`bg-transparent text-left flex justify-start items-center gap-2 transition-all ${
              currPage === "inbox" ? "bg-gray-800 font-bold" : ""
            } [@media(max-height:700px)]:h-8 [@media(max-height:700px)]:rounded-md [@media(max-height:700px)]:px-3 [@media(max-height:700px)]:text-xs`}
            onClick={() => nav(ROUTE_INBOX)}
          >
            <Inbox
              className={`!size-4 [@media(max-height:700px)]:!size-[14px]`}
            />
            Inbox
          </Button>
          <Button
            variant={"ghost"}
            className={`bg-transparent text-left flex justify-start items-center gap-2 transition-all ${
              currPage === "tags" ? "bg-gray-800 font-bold" : ""
            } [@media(max-height:700px)]:h-8 [@media(max-height:700px)]:rounded-md [@media(max-height:700px)]:px-3 [@media(max-height:700px)]:text-xs`}
            onClick={() => nav(ROUTE_TAGS)}
          >
            <Tags
              className={`!size-4 [@media(max-height:700px)]:!size-[14px]`}
            />
            Tags
          </Button>
          {/* <Button
            variant={"ghost"}
            className={`bg-transparent text-left flex justify-start items-center gap-2 transition-all ${
              currPage === "metrics" ? "bg-gray-800 font-bold" : ""
            } [@media(max-height:700px)]:h-8 [@media(max-height:700px)]:rounded-md [@media(max-height:700px)]:px-3 [@media(max-height:700px)]:text-xs`}
            onClick={() => nav(ROUTE_METRICS)}
          >
            <ChartColumn
              className={`!size-4 [@media(max-height:700px)]:!size-[14px]`}
            />
            Metrics
          </Button> */}
          <hr />
        </div>

        {/* Favorites */}
        <SidebarFavorites currPage={currPage} />
      </div>
    </div>
  );
};

export default Sidebar;
